export { default } from './OrganizationsStore';



// WEBPACK FOOTER //
// ./src/stores/OrganizationsStore/index.ts